import { wpRESTGet } from './wpREST';

export async function getClinicsCity(city_id) {
  return wpRESTGet(`app/v1/clinics/${city_id}`);
}
